/**
 * Copyright 2026 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

import { type Placement } from '../controllers/placement-controller/index.js';

/**
 * The physical side (`'top'` / `'bottom'` / `'left'` / `'right'`) of a placement,
 * dropping any alignment suffix (for example `'bottom-start'` becomes `'bottom'`).
 * Use for the `PlacementController`'s `onPlacementChange`, whose argument is
 * already a resolved physical placement.
 *
 * @param placement - A resolved (physical) placement value.
 */
export function physicalSide(placement: Placement): string {
  return placement.split('-')[0];
}
